import React, { useState, useEffect } from "react";
import Layout from "../components/layout";
import toast from "react-hot-toast";
import UpdateData from "./UpdateData";
import { Tabs } from "antd";
import "../index.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";
const { TabPane } = Tabs;

const SantymedProcessing = () => {
  const [file, setFile] = useState(null);
  const [manipulationType, setManipulationType] = useState("");
  const [loading, setLoading] = useState(false); // Add loading state
  const [logs, setLogs] = useState([]);
  const [errorMessage, setErrorMessage] = useState(""); // Add error message state
  const [filesList, setFilesList] = useState([]);
  const [canvaList, setCanvaList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [canvaError, setCanvaError] = useState(null);
  const [error, setError] = useState(null);

  // Get admin status from Redux store
  const isAdmin = useSelector((state) => state.user.user?.type === "Admin");
  const isAfl = useSelector((state) => state.user.user?.type === "Afl");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const socket = io(
    `${process.env.REACT_APP_API_URL.replace("https", "wss").replace(
      "/api",
      ""
    )}:${process.env.REACT_APP_PORT || 3000}`
  );

  const handleUpload = async () => {
    if (!manipulationType) {
      alert("Please select a manipulation type.");
      return;
    }

    setLoading(true); // Start loading
    setErrorMessage(""); // Clear previous error

    const formData = new FormData();
    formData.append("filexl", file);
    formData.append("manipulationType", manipulationType);

    let endpoint = "";
    switch (manipulationType) {
      case "create":
        endpoint = `${process.env.REACT_APP_API_URL}/auth/add-patients-excel`;
        break;
      case "santymed":
        endpoint = `${process.env.REACT_APP_API_URL}/auth/process-all-santymed`;
        break;
      case "update":
        endpoint = `${process.env.REACT_APP_API_URL}/santymed/update`;
        break;
      case "delete":
        endpoint = `${process.env.REACT_APP_API_URL}/santymed/delete`;
        break;
      default:
        alert("Invalid manipulation type.");
        setLoading(false); // Stop loading if invalid type
        return;
    }

    axios
      .post(endpoint, formData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          headers: {
            "x-socket-id": socket.id,
          },
        },
      })
      .then((response) => {
        setLoading(false); // Stop loading
        if (response.data.success === true) {
          console.log("response: ", response.data.success);
          toast.success(response.data.message);
        }
      })
      .catch((err) => {
        setLoading(false); // Stop loading
        setErrorMessage("An error occurred during upload."); // Set error message
        console.error("Upload error:", err);
      });
  };

  // 2nd tab (files list)

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/files`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setFilesList(response.data);
        setError(null);
      } catch (err) {
        console.error("Error fetching files:", err);
        setError("Failed to fetch files. Please check the console.");
      }
    };

    fetchFiles();
  }, []);

  // 3rd tab (canva list)

  useEffect(() => {
    const fetchCanva = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/canva`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setCanvaList(response.data);
        setCanvaError(null);
      } catch (err) {
        console.error("Error fetching canva:", err);
        setCanvaError("Failed to fetch canva. Please check the console.");
      }
    };

    fetchCanva();
  }, []);

  // show "logs" during patient export to santymed

  useEffect(() => {
    console.log("Connecting socket...");

    socket.on("connect", () => {
      console.log("🟢 Connected to socket.io server", socket.id);
    });

    socket.on("excel-upload-progress", (log) => {
      console.log("📩 Socket log received:", log.message);
      setLogs((prev) => [...prev, log.message]);
    });

    return () => socket.disconnect();
  }, []);

  const handleCheckboxChange = (filename) => {
    if (selectedFiles.includes(filename)) {
      setSelectedFiles(selectedFiles.filter((f) => f !== filename));
    } else {
      setSelectedFiles([...selectedFiles, filename]);
    }
  };

  const handleDownloadFiles = async () => {
    try {
      if (selectedFiles.length === 0) {
        alert("Please select files to download.");
        return;
      }

      for (const filename of selectedFiles) {
        const downloadResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/download-files/${filename}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(
          new Blob([downloadResponse.data])
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
      console.error("Error downloading files:", err);
      setError("Failed to download files. Please check the console.");
    }
  };

  const handleDownloadCanva = async () => {
    try {
      if (selectedFiles.length === 0) {
        alert("Please select files to download.");
        return;
      }

      for (const filename of selectedFiles) {
        const downloadResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/download-canva/${filename}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(
          new Blob([downloadResponse.data])
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
      console.error("Error downloading files:", err);
      setError("Failed to download files. Please check the console.");
    }
  };

  return (
    <Layout>
      <Tabs defaultActiveKey="1">
        {isAdmin && (
          <TabPane tab="Vers Santymed" key="1">
            <div className="px-5 mt-3">
              <div className="d-flex justify-content-center">
                <h3 className="page-title">Exporter des données test</h3>
              </div>

              <div className="button-group">
                <button
                  className={manipulationType === "create" ? "active" : ""}
                  onClick={() => setManipulationType("create")}
                >
                  Exporter Patients
                </button>
                <button
                  className={manipulationType === "update" ? "active" : ""}
                  onClick={() => setManipulationType("update")}
                >
                  Modifier Patients
                </button>
              </div>
            </div>
            <div className="file-import">
              <input
                type="file"
                name="excelFile"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
              />
              <button
                style={{
                  backgroundColor: "#AF47E8",
                }}
                className="btn btn-primary px-3"
                onClick={handleUpload}
                disabled={loading} // Disable button during loading
              >
                {loading ? "En cours..." : "Confirmer"}
                {/* Show loading message */}
              </button>
              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}
              {logs.length > 0 && (
                <div className="upload-logs mt-3 p-3 bg-light border rounded">
                  <h5>Progression :</h5>
                  <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                    {logs.map((msg, idx) => (
                      <li key={idx} style={{ marginBottom: "0.5rem" }}>
                        {msg}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </TabPane>
        )}

        {/* If admin then can see content of the fie list */}
        {isAdmin && (
          <>
            <TabPane tab="Vers AGA" key="2">
              <UpdateData />
            </TabPane>
            <TabPane tab="Fichiers reçus" key="3">
              <div className="container mt-4">
                <h2>File List</h2>
                {error && <div className="alert alert-danger">{error}</div>}
                {filesList.length > 0 ? (
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Select</th>
                        <th>Nom</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filesList.map((file) => (
                        <tr key={file}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedFiles.includes(file)}
                              onChange={() => handleCheckboxChange(file)}
                            />
                          </td>
                          <td>{file}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No files found.</p>
                )}
                <button
                  style={{
                    backgroundColor: "#AF47E8",
                  }}
                  className="btn btn-primary px-3"
                  onClick={handleDownloadFiles}
                >
                  Télécharger
                </button>
              </div>
            </TabPane>
          </>
        )}
        <TabPane tab="Documentations" key="4">
          <div className="container mt-4">
            <h2>A Télécharger</h2>
            {error && <div className="alert alert-danger">{error}</div>}
            {canvaList.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Nom</th>
                  </tr>
                </thead>
                <tbody>
                  {canvaList.map((file) => (
                    <tr key={file}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedFiles.includes(file)}
                          onChange={() => handleCheckboxChange(file)}
                        />
                      </td>
                      <td>{file}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No files found.</p>
            )}
            <button
              style={{
                backgroundColor: "#AF47E8",
              }}
              className="btn btn-primary px-3"
              onClick={handleDownloadCanva}
            >
              Télécharger
            </button>
          </div>
        </TabPane>
      </Tabs>
    </Layout>
  );
};

export default SantymedProcessing;
